import { useNavigate } from 'react-router';
import { useCallback } from 'react';

export default function useRedirect() {
  const navigate = useNavigate();
  const redirect = useCallback(
    (urlStr: string) => {
      const url = new URL(urlStr);
      if (url.origin === window.location.origin) {
        navigate(url.pathname);
        return;
      }
      window.location.assign(url);
    },
    [navigate],
  );

  return redirect;
}
